import React, { useImperativeHandle } from 'react';
import { useMap } from "react-leaflet";
import {
  TerraDraw,
  TerraDrawLeafletAdapter,
  TerraDrawLineStringMode,
  TerraDrawSelectMode, ValidateNotSelfIntersecting
} from "terra-draw";
import * as L from "leaflet";
import useAxiosPrivate from "../../hooks/useAxiosPrivate";
import { useTranslation } from "react-i18next";

const TerraDrawComponent = React.forwardRef((props, ref) => {
  const axiosPrivate = useAxiosPrivate();
  const { t } = useTranslation();
  const draw = new TerraDraw({
    adapter: new TerraDrawLeafletAdapter({
      lib: L,
      map: useMap()
    }),
    modes: [
      new TerraDrawSelectMode({
        projection: "web-mercator",
        flags: {
          linestring: {
            feature: {
              coordinates: {
                midpoints: true,
                draggable: true,
                deletable: true,
              }
            }
          },
        },
      }),
      new TerraDrawLineStringMode({
        snapping: true,
        insertCoordinates: {
          strategy: "amount",
          value: 8,
        },
        validation: (feature, { updateType }) => {
          if (updateType === "finish" || updateType === "commit") {
            return ValidateNotSelfIntersecting(feature);
          }
          return true;
        }
      }),
    ],
  });

  draw.start();
  draw.setMode("select");
  console.log("Initializing TDC", draw);

  const setMode = (mode) => {
    if (!draw.enabled) {
      draw.start();
    }
    draw.setMode(mode);
  };

  const clear = () => {
    draw.clear()
  };

  const updateDatabase = async () => {
    const features = draw.getSnapshot();
    if (!features) {
      console.warn("Snapshot is empty");
      return;
    }

    const linestrings = features.filter((feature) => feature.properties.mode === "linestring");
    const uniqueCoordinatesSet = new Set();

     const coordinates = linestrings
      .flatMap((linestring) => {
        return linestring.geometry.coordinates.map((coordinate) => {
          const lat = coordinate[1];
          const lon = coordinate[0];
          const key = `${lat}-${lon}`;

          if (!uniqueCoordinatesSet.has(key)) {
            uniqueCoordinatesSet.add(key);
            return {
              longitude: lon,
              latitude: lat
            };
          }

          return null;
        });
      })
      .filter(coordinate => coordinate && coordinate.latitude !== undefined && coordinate.longitude !== undefined);

    console.log("Updating coordinates", coordinates);

    try {
      await axiosPrivate.post(
        "/cemetery/coordinates",
        JSON.stringify(coordinates)
      ).then((coordinates) => {
        const dbCoordinates = {};
        coordinates.data.map((coordinate) => {
          dbCoordinates[coordinate.longitude + " " + coordinate.latitude] = coordinate.id;
        })
        const edges = [];
        linestrings.forEach((linestring) => {
          for (var i = 0; i < linestring.geometry.coordinates.length - 1; i++) {
            edges.push({
              source: dbCoordinates[linestring.geometry.coordinates[i][0] + " " + linestring.geometry.coordinates[i][1]],
              target: dbCoordinates[linestring.geometry.coordinates[i + 1][0] + " " + linestring.geometry.coordinates[i + 1][1]],
            })
          }
        })
        axiosPrivate.post(
          "/cemetery/edges",
          JSON.stringify(edges)
        ).then((edges) => {
          console.log("Edges put in database:", edges);
          alert(t("successfulUpdate"));
        })
      })
    } catch (error) {
      alert(error.message);
    }
  }

  useImperativeHandle(ref, () => ({
    setMode, clear, updateDatabase
  }), []);

  return null;
});

export default TerraDrawComponent;
